import editIcon from "components/icons/edit_icon.svg";
import shareIcon from "components/icons/share_icon_red.svg";
import manageIcon from "components/icons/manage_icon.svg";

export const getCollectionMenu = ({ actions }: any) => {
  const { onEdit, onShare, onManage } = actions;

  return [
    {
      groupName: null,
      groupMobileName: null,
      items: [
        {
          icon: editIcon,
          title: "Edit",
          onClick: onEdit
        },
        {
          icon: shareIcon,
          title: "Share",
          onClick: onShare
        },
        {
          icon: manageIcon,
          title: "Manage",
          onClick: onManage
        }
      ]
    }
  ];
};
